export function checkSearchResult(searchText: string, input: string) {
  const purifiedSearchText = searchText
    .replace(/[^A-Za-z0-9#]/g, '')
    .toLowerCase()
  const purifiedRow = input.replace(/[^A-Za-z0-9#]/g, '').toLowerCase()

  return purifiedRow.indexOf(purifiedSearchText) !== -1
}
